import { render } from "./App.vue?vue&type=template&id=3cc18dcd"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3cc18dcd&lang=less"

import exportComponent from "C:\\webproject\\mofa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__